import React, { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AdminHomeHelper from '../../../Components/AdminHomeHelper'
import Loading from '../../../Components/Loading';

const AdminStudentView = () => {
    const { studentId } = useParams();
    const [activeSection, setActiveSection] = useState('personal'); // 'personal', 'fees', or 'academic'
    const student = useSelector((store) => {
        return store.admin.allStudent.find((student) => student._id === studentId);
    });
    if (!student) {
        return <div>Student not found</div>;
    }
    const isStudentDataAvailable = student.name && student.name.length > 0;

    return (
        <div>
            <div className="container-fluid p-0">
                <div className="d-flex">
                    <div className="print-helper">
                        <AdminHomeHelper />
                    </div>
                    <div className="mx-1 w-100 ">
                        <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                            <h5><Link to='/admin/allStudents' className='text-light'><img src="/image/Back.svg" className='p-2' alt="" /></Link></h5>
                            <h3> <img src="/logo192.png" width={'50px'} alt="" /> {student.name}</h3>
                            <button onClick={() => window.print()} type="button" className="print-helper btn-success btn text-light"> <img src="/image/print.svg" lt="" /> <span className=''>Download</span></button>
                        </div>
                        <div className="col bg-light d-md-flex align-items-center justify-content-between">
                            <div className="stuData">
                                <div className="row ">
                                    <div className='col-md-4 sortDetails overflow-hidden'>
                                       <img className="img-fluid" width={'250px'} src={student.avatar} alt="Card image cap" />
                                       <h5 className='bg-dark text-light p-1 w-100'>{student.name}</h5>
                                            <h6 className='d-flex align-items-center'>
                                                <img src="/image/mail.svg" alt="" className='p-1' />
                                                <span className="">{student.email}</span>
                                            </h6>
                                            <h6 className='d-flex align-items-center'>
                                                <img src="/image/phone.svg" alt="" className='p-1' />
                                                <span className="">{student.studentMobileNumber}</span>
                                            </h6>
                                            <h6 className={`badge badge-${student.status === 'active' ? 'success' : student.status === 'irregular' ? 'warning' : 'danger'}`}>
                                                {student.status}
                                            </h6>
                                            <hr/>
                                    </div>
                                    <div className='col-md-8'>
                                    <div className="d-flex  my-3 col">
                                        <button onClick={() => setActiveSection('personal')} className="btn btn-primary mx-3">Mentee's Details</button>
                                        <button onClick={() => setActiveSection('fees')} className="btn btn-primary ml-3">Fees Details</button>
                                        <button onClick={() => setActiveSection('academic')} className="btn btn-primary ml-3">Academic Performance</button>
                                        <button onClick={() => setActiveSection('complaints')} className="btn btn-primary mx-3">Complaints</button>
                                    </div>
                                    <hr />
                                    {activeSection === 'academic' && (
                                        <div className='col'>
                                            <h4>Academic Performance</h4>
                                            <div className='d-flex align-items-center bordr'>
                                                <h5 className='text-danger'><b>0 ARREAR'S AS ON {new Date().toLocaleDateString('en-GB')}</b></h5>
                                            </div>

                                            <table className="table table-bordered table-striped">
                                                <thead className="thead-dark">
                                                    <tr>
                                                        <th>Semester</th>
                                                        <th>Subject Code</th>
                                                        <th>Grade</th>
                                                        <th>Result</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>05</td>
                                                        <td>CB3491</td>
                                                        <td>B+</td>
                                                        <td>PASS</td>
                                                    </tr>
                                                    <tr>
                                                        <td>05</td>
                                                        <td>CCS334</td>
                                                        <td>A</td>
                                                        <td>PASS</td>
                                                    </tr>
                                                    <tr>
                                                        <td>05</td>
                                                        <td>CCS375</td>
                                                        <td>A</td>
                                                        <td>PASS</td>
                                                    </tr>
                                                    <tr>
                                                        <td>05</td>
                                                        <td>CS3501</td>
                                                        <td>A</td>
                                                        <td>PASS</td>
                                                    </tr>
                                                    <tr>
                                                        <td>05</td>
                                                        <td>CS3551</td>
                                                        <td>B+</td>
                                                        <td>PASS</td>
                                                    </tr>
                                                    <tr>
                                                        <td>05</td>
                                                        <td>CS3591</td>
                                                        <td>A</td>
                                                        <td>PASS</td>
                                                    </tr>
                                                    <tr>
                                                        <td>05</td>
                                                        <td>MX3084</td>
                                                        <td>A+</td>
                                                        <td>PASS</td>
                                                    </tr>
                                                    <tr>
                                                        <td>05</td>
                                                        <td>SB3001</td>
                                                        <td>O</td>
                                                        <td>PASS</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                    {activeSection === 'complaints' && (
                                        <div className='col'>
                                            <h4>Complaints</h4>
                                            <div className='d-flex align-items-center bordr'>
                                                <h5 className='text-danger'><b>0 COMPLAINTS AS ON {new Date().toLocaleDateString('en-GB')}</b></h5>
                                            </div>

                                            <table className="table table-bordered table-striped">
                                                <thead className="thead-dark">
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>Date</th>
                                                        <th>Complaint</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                   
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                    {activeSection === 'fees' && (
                                        <div className='col'>
                                            <h4>Fees Details</h4>
                                            <div className='d-flex align-items-center bordr'>
                                                <h5 className='text-danger'><b>NO DUES AS ON {new Date().toLocaleDateString('en-GB')}</b></h5>
                                            </div>

                                            <table className="table table-bordered table-striped">
                                                <thead className="thead-dark">
                                                    <tr>
                                                        <th>Item</th>
                                                        <th>Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>Tuition Fees</td>
                                                        <td>₹45,000</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Hostel Fees</td>
                                                        <td>₹0</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Bus Fees</td>
                                                        <td>₹9,000</td>
                                                    </tr>
                                                    <tr>
                                                        <td><b>Total</b></td>
                                                        <td><b>₹54,000</b></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                    {activeSection === 'personal' && (
                                        <div className="table-responsive col border col-12">
                                            <h4>Personal Details</h4>
                                            {isStudentDataAvailable ? (
                                                <table className="table shTable table-striped table-bordered">
                                                    <thead className="thead-dark">
                                                        <tr>
                                                            <th>Attribute</th>
                                                            <th>Details</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>Name</td>
                                                            <td>{student.name}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Email</td>
                                                            <td><small>{student.email}</small></td>
                                                        </tr>
                                                        <tr>
                                                            <td>Registration Number</td>
                                                            <td>{student.registrationNumber}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Date Of Birth</td>
                                                            <td>{student.dob}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Year</td>
                                                            <td>{student.year}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Semester</td>
                                                            <td>{student.semester}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Department</td>
                                                            <td>{student.department}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Section</td>
                                                            <td>{student.section}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Branch</td>
                                                            <td>{student.branch}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Gender</td>
                                                            <td>{student.gender ? student.gender : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Contact Number</td>
                                                            <td>{student.studentMobileNumber ?
                                                                student.studentMobileNumber : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Blood group</td>
                                                            <td>{student.bloodGroup ? student.bloodGroup : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>EMIS Number</td>
                                                            <td>{student.emisNumber ? student.emisNumber : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Religion</td>
                                                            <td>{student.Religion ? student.Religion : "NA"} </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Community</td>
                                                            <td>{student.Community ? student.Community : "NA"} </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Caste</td>
                                                            <td>{student.Caste ? student.Caste : "NA"} </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Aadhar number</td>
                                                            <td>{student.aadharCard ? student.aadharCard : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>First graduate</td>
                                                            <td>{student.FirstGraduate ? student.FirstGraduate : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Special admission</td>
                                                            <td>{student.SpecialAdmission ? student.SpecialAdmission : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Permanent address</td>
                                                            <td ><small>{student.address ? student.address : "NA"}</small></td>
                                                        </tr>
                                                        <tr>
                                                            <td>Fathers name</td>
                                                            <td>{student.fatherName ? student.fatherName : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Fathers occupation</td>
                                                            <td>{student.fatherOccupation ? student.fatherOccupation : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Mother name</td>
                                                            <td>{student.motherName ? student.motherName : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Mother’s occupation</td>
                                                            <td>{student.MotherOccupation ? student.MotherOccupation : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Parent Contact Number</td>
                                                            <td>{student.fatherMobileNumber ? student.fatherMobileNumber : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Annual family income</td>
                                                            <td>{student.AnnualIncome ? student.AnnualIncome : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Bank account number</td>
                                                            <td>{student.BankAccountNumber ? student.BankAccountNumber : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>IFSC code</td>
                                                            <td>{student.IFSCcode ? student.IFSCcode : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Bank name</td>
                                                            <td>{student.BankName ? student.BankName : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Bank branch</td>
                                                            <td>{student.BankBranch ? student.BankBranch : "NA"}</td>
                                                        </tr>

                                                        <tr>
                                                            <td>Academic year of joining</td>
                                                            <td>{student.AcademicYear ? student.AcademicYear : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Date of admission</td>
                                                            <td>{student.DateOfadmission ? student.DateOfadmission : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Type of admission</td>
                                                            <td>{student.TypeOfAdmission ? student.TypeOfAdmission : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Counseling Number</td>
                                                            <td>{student.CounselingNumber ? student.CounselingNumber : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>lateral entry</td>
                                                            <td>{student.lateralEntry ? student.lateralEntry : "NA"}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Hosteller</td>
                                                            <td>{student.Hosteller ? student.Hosteller : "NA"}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <Loading />

                                            )}
                                        </div>
                                    )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default AdminStudentView
